export interface Theme {
  title: string;
  slug: string;
  image?: string;
  description: string;
}

// Theme options for initiative multi-select (key matches slug from THEMES array)
export const INITIATIVE_THEME_OPTIONS = [
  { key: 'workplace', label: 'Workplace' },
  { key: 'goodie-bags', label: 'Goodie Bags' },
  // { key: 'sampling-tastings', label: 'Sampling & Tastings' },
  { key: 'campus', label: 'Campus & Students' },
  { key: 'pets', label: 'Pets' },
  { key: 'social-networking', label: 'Social & Networking' },
  { key: 'brand-collaborations', label: 'Brand Collaborations' },
] as const;

export const THEMES: Theme[] = [
  {
    title: 'Workplace',
    slug: 'workplace',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop',
    description: 'Office pantries, team events, wellness programs, and corporate gifting.',
  },
  {
    title: 'Goodie Bags',
    slug: 'goodie-bags',
    image: 'https://images.unsplash.com/photo-1673257042397-3ddb58a83435?w=800&h=600&fit=crop',
    description: 'Curated product packs for events, conferences, welcome kits, and giveaways.',
  },
  //   {
  //     title: 'Sampling & Tastings',
  //     slug: 'sampling-tastings',
  //     image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop',
  //   description:
  //     'Product tastings, sampling events, and feedback sessions that connect emerging brands with engaged consumers.',
  // },
  {
    title: 'Campus',
    slug: 'campus',
    image: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&h=600&fit=crop',
    description:
      'Campus activations, student sampling, club sponsorships, and brand partnerships at colleges and universities.',
  },
  // {
  //   title: 'Costco',
  //   slug: 'costco',
  //   image: '',
  //   description:
  //     'In-store demos, roadshows, seasonal campaigns, and new item introductions at Costco warehouses.',
  // },
  {
    title: 'Pets',
    slug: 'pets',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=600&fit=crop',
    description:
      'Pet food sampling, vet clinic activations, dog park events, and brand partnerships for the pet industry.',
  },
  {
    title: 'Social & Networking',
    slug: 'social-networking',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=600&fit=crop',
    description:
      'Networking events, social mixers, industry meetups, and brand activations that bring people together.',
  },
  {
    title: 'Brand Collaborations',
    slug: 'brand-collaborations',
    image: '/static/themes/brand-collaborations-product-a-x-product-b.png',
    description:
      'Cross-brand partnerships, co-branded campaigns, joint promotions, and collaborative product launches.',
  },
  // {
  //   title: 'Costco',
  //   slug: 'costco',
  //   image: '',
  //   description:
  //     'In-store demos, roadshows, seasonal campaigns, and new item introductions at Costco warehouses.',
  // },
  // {
  //   title: 'Hospitality',
  //   slug: 'hospitality',
  //   image: '',
  //   description: 'Hotels, restaurants, bars, and cafes looking for brand partnerships.',
  // },
  // {
  //   title: 'Events & Festivals',
  //   slug: 'events-festivals',
  //   image: '',
  //   description: 'Music festivals, food fairs, markets, and community gatherings.',
  // },
  // {
  //   title: 'Health & Wellness',
  //   slug: 'health-wellness',
  //   image: '',
  //   description: 'Gyms, yoga studios, wellness retreats, and health-focused spaces.',
  // },
  // {
  //   title: 'Education',
  //   slug: 'education',
  //   image: '',
  //   description: 'Schools, universities, and training centres seeking brand collaborations.',
  // },
  // {
  //   title: 'Retail',
  //   slug: 'retail',
  //   image: '',
  //   description: 'Independent retailers, pop-up shops, and specialty stores.',
  // },
  // {
  //   title: 'Sports & Recreation',
  //   slug: 'sports-recreation',
  //   image: '',
  //   description: 'Sports clubs, recreation centres, and active lifestyle venues.',
  // },
  // {
  //   title: 'Community',
  //   slug: 'community',
  //   image: '',
  //   description: 'Community groups, charities, and not-for-profit organisations.',
  // },
];
